// PLAN-30 P4: a job's machine cost from the machine that did the work.
// Reuses the finance axios instance (baseURL /api/finance; nginx rewrites to /api/v1).
import api from './finance'

export const machineJobCostAPI = {
  // "Job cost for machines comes from" - the value in force on `on` (the person's own today), any change
  // scheduled, and every change with who made it. Not money.
  setting:     (on)       => api.get('/machine-job-cost/setting', { params: on ? { on } : {} }),
  // A new dated change (administrators). Re-posts nothing.
  saveSetting: (body, on) => api.put('/machine-job-cost/setting', body, { params: on ? { on } : {} }),
  // Before switching on: job cost under each rule for a date range (one job, or all). Writes nothing.
  count:       (params)   => api.get('/machine-job-cost/count', { params }),
  // The office's deliberate re-post of a range. `dry_run: true` answers what it would do and writes nothing.
  repost:      (body)     => api.post('/machine-job-cost/repost', body),
  // Machine lines waiting for a cost: on a job (`project_id`), for a machine (`unit_id`), or all. No figures.
  waiting:     (params)   => api.get('/machine-cost/waiting', { params }),
  postWaiting: (pid, body = {}) => api.post(`/projects/${pid}/machine-cost/waiting/post`, body),
  // The job's machine cost, machine by machine (project money).
  byMachine:   (pid)      => api.get(`/projects/${pid}/machine-cost/by-machine`),
}

/** A refused request in words: the server's sentence, or the fallback. */
export function refusalText(err, fallback) {
  const detail = err?.response?.data?.detail
  if (typeof detail === 'string' && detail) return detail
  if (Array.isArray(detail) && detail.length) {
    return detail.map(d => String(d?.msg ?? '').replace(/^Value error, /, '')).filter(Boolean).join(' ') || fallback
  }
  return fallback
}

/** A money figure from the server ("496.00"), "Hidden" when withheld, a dash when there is none. */
export function moneyText(row, field) {
  if ((row?.withheld_fields || []).includes(field)) return 'Hidden'
  const v = row?.[field]
  if (v == null || v === '') return '—'
  const n = Number(v)
  return Number.isFinite(n) ? `$${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '—'
}
